module.exports = __webpack_public_path__ + "static/ocean-bay-park-hero.8234bd8e.jpg";